import React from 'react';

// Shared device search input for grid and list views. Matching itself is
// done by the caller (see matchesDeviceSearch in Dashboard.jsx).
export const matchesDeviceSearch = (d, q) => {
  if (!q) return true;
  const needle = q.toLowerCase();
  return [d.devkit_id, d.company, d.vessel_name, d.tailscale?.hostname]
    .some((v) => v && String(v).toLowerCase().includes(needle));
};

export default function DeviceSearchBar({ value, onChange, matchCount, totalCount }) {
  return (
    <div className="flex items-center justify-between gap-4 w-full">
      <div className="relative flex-1 max-w-sm">
        <svg
          className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400 pointer-events-none"
          viewBox="0 0 24 24" fill="none"
        >
          <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2" />
          <path d="M20 20l-3.5-3.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Search device, company, vessel, hostname…"
          className="w-full pl-9 pr-8 py-1.5 text-sm rounded-lg border border-gray-300 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        />
        {value && (
          <button
            onClick={() => onChange('')}
            className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
            title="Clear search"
          >
            ✕
          </button>
        )}
      </div>
      <span className="text-xs text-gray-500 whitespace-nowrap">
        {matchCount} of {totalCount} devices
      </span>
    </div>
  );
}
